var PostStatus;
(function (PostStatus) {
  /** DRAFT - Post not available, because the author has not published it yet */
  PostStatus["DRAFT"] = "draft";
  /** PUBLISHED - Post available */
  PostStatus["PUBLISHED"] = "published";
})(PostStatus || (PostStatus = {}));

export { PostStatus };
